<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h1>AI Use Case Requests</h1>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="requests"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="approveRequest(item)" v-if="item.status === 'pending'">
              mdi-check
            </v-icon>
            <v-icon small class="mr-2" @click="declineRequest(item)" v-if="item.status === 'pending'">
              mdi-close
            </v-icon>
            <v-icon small @click="deleteRequest(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
     <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="6000">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { getFirestore, collection, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';

export default {
  name: 'UseCaseRequestsAdmin',
  data() {
    return {
      loading: false,
      requests: [],
      headers: [
        { text: 'Title', value: 'title' },
        { text: 'Department', value: 'department' },
        { text: 'Contact', value: 'contact' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      snackbar: {
        show: false,
        message: '',
        color: '',
      },
    };
  },
  created() {
    this.fetchRequests();
  },
  methods: {
    async fetchRequests() {
      this.loading = true;
      try {
        const db = getFirestore();
        const querySnapshot = await getDocs(collection(db, 'useCaseRequests'));
        this.requests = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      } catch (error) {
        console.error('Error fetching requests:', error);
        this.showSnackbar('Error fetching requests.', 'error');
      } finally {
        this.loading = false;
      }
    },
    async updateRequestStatus(item, status) {
      this.loading = true;
      try {
        const db = getFirestore();
        const requestRef = doc(db, 'useCaseRequests', item.id);
        await updateDoc(requestRef, { status: status });
        this.showSnackbar(`Request ${status}.`, 'success');
        this.fetchRequests(); // Refresh the list
      } catch (error) {
        console.error(`Error updating request to ${status}:`, error);
        this.showSnackbar(`Error updating request.`, 'error');
      } finally {
        this.loading = false;
      }
    },
    approveRequest(item) {
      this.updateRequestStatus(item, 'approved');
    },
    declineRequest(item) {
      this.updateRequestStatus(item, 'declined');
    },
    async deleteRequest(item) {
        if(confirm('Are you sure you want to delete this request?')) {
            this.loading = true;
            try {
                const db = getFirestore();
                await deleteDoc(doc(db, 'useCaseRequests', item.id));
                this.showSnackbar('Request deleted.', 'success');
                this.fetchRequests(); // Refresh the list
            } catch (error) {
                console.error('Error deleting request:', error);
                this.showSnackbar('Error deleting request.', 'error');
            } finally {
                this.loading = false;
            }
        }
    },
    showSnackbar(message, color) {
        this.snackbar.message = message;
        this.snackbar.color = color;
        this.snackbar.show = true;
    }
  },
};
</script> 